export default __webpack_public_path__ + "static/media/ios_step_2_Hk.49608faf.jpg";